import { PhpArray, intval, ksort, phpCopy } from '../../../../php-compat';
import type { PhpRef, PortEnv } from '../../../../port-contract';
import { array, isArray, put, record, remove } from '../../array-path';

export interface PreparedSpellDeps {
    layer_entries(host: unknown, layer: string): unknown;
    item_arr_scalar_layer_slot(entry: unknown): unknown;
    check_uuid(id: unknown): boolean;
    query_full_item_arr(id: unknown, debug_variable_name: null, creature_preview_skip_finalize: boolean,
        suppress_missing_item_warning: boolean): unknown;
    layer_has(host: unknown, layer: string): boolean;
    layer_value(host: unknown, layer: string): unknown;
    item_field(host: unknown, field: string): unknown;
}
/** PHP: compute_spells_prepared (includes/functions/janus/core/compute/spells_prepared.php:22) */
export function computeSpellsPrepared(item_arr: PhpRef<unknown>, env: PortEnv<PreparedSpellDeps>): null {
    const host = phpCopy(array(item_arr.value)), lists = new PhpArray();
    for (const [index, layer] of ['spell_prepared_1', 'spell_prepared_2', 'spell_prepared_3'].entries()) {
        const entries = array(env.deps.layer_entries(host, layer));
        if (entries.size === 0) continue;
        const by_level = new PhpArray();
        for (const entry of entries.values()) {
            const spell_id = env.deps.item_arr_scalar_layer_slot(entry);
            if (spell_id === '' || spell_id === null || !env.deps.check_uuid(spell_id)) continue;
            const spell = env.deps.query_full_item_arr(spell_id, null, false, true);
            if (!isArray(spell)) continue;
            const level = env.deps.layer_has(spell, 'spell_level') ? intval(env.deps.layer_value(spell, 'spell_level')) : 0;
            if (!by_level.has(level)) by_level.set(level, new PhpArray());
            array(by_level.get(level)).append(record({ item_id: spell_id, item_name: env.deps.item_field(spell, 'item_name') ?? '' }));
        }
        if (by_level.size === 0) continue;
        const levels = new PhpArray();
        for (const [level, spells] of ksort(by_level)) levels.append(record({ level: intval(level), spells }));
        lists.append(record({ list: index + 1, levels }));
    }
    if (lists.size === 0) remove(host, 'computed', 'creature', 'spells_prepared');
    else put(host, ['computed', 'creature', 'spells_prepared'], record({ lists }));
    item_arr.value = host;
    return null;
}
